import { Link } from 'react-router-dom';
import { Carousel, Image } from 'react-bootstrap';
import Message from './Message';
import { useGetTopProductsQuery } from '../slices/productsApiSlice';
import './ProductCarousel.css'; // ✅ import a dedicated stylesheet

const ProductCarousel = () => {
  const { data: products, isLoading, error } = useGetTopProductsQuery();

  return isLoading ? null : error ? (
    <Message variant="danger">{error?.data?.message || error.error}</Message>
  ) : (
    <Carousel
      pause="hover"
      className="product-carousel mb-4 shadow rounded"
      indicators={true}
      fade={true}
    >
      {products.map((product) => (
        <Carousel.Item key={product._id}>
          <Link to={`/product/${product._id}`}>
            <Image
              src={product.images}
              alt={product.name}
              className="d-block w-100 product-carousel-image"
            />
            <Carousel.Caption className="product-carousel-caption">
              <h2 className="fw-bold text-white">
                {product.name} (GMD{product.price})
              </h2>
            </Carousel.Caption>
          </Link>
        </Carousel.Item>
      ))}
    </Carousel>
  );
};

export default ProductCarousel;